import { differenceInMinutes, subMinutes, getTime, format } from 'date-fns';
import { utcToZonedTime, getTimezoneOffset } from 'date-fns-tz';

type ZonedToUtcDateTimeType = (timestamp: number, timeZone: string) => Date; // TODO: remove

export const zonedToUtcDateTime: ZonedToUtcDateTimeType = (timestamp, timeZone) => {
    // TODO: remove
    const eventTimezoneDateTime = utcToZonedTime(timestamp, timeZone);
    const utcTimezoneDateTime = utcToZonedTime(timestamp, 'Etc/UTC');
    const eventTimezoneOffset = differenceInMinutes(eventTimezoneDateTime, utcTimezoneDateTime);
    const utcDateTime = subMinutes(timestamp, eventTimezoneOffset);
    return utcDateTime;
};
type ZonedToUtcTimestampType = (timestamp: number, timeZone: string) => number;

export const zonedToUtcTimestamp: ZonedToUtcTimestampType = (timestamp, timeZone) => {
    const eventTimezoneDateTime = utcToZonedTime(timestamp, timeZone);
    const utcTimezoneDateTime = utcToZonedTime(timestamp, 'Etc/UTC');
    const eventTimezoneOffset = differenceInMinutes(eventTimezoneDateTime, utcTimezoneDateTime);
    const utcDateTime = subMinutes(timestamp, eventTimezoneOffset);
    return getTime(utcDateTime);
};

export const getTimeZoneOffsetInMs = (timestamp: number) =>
    new Date(timestamp).getTimezoneOffset() * 60 * 1000;

type GetUserTimeZone = () => string;
export const getUserTimeZone: GetUserTimeZone = () =>
    new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];

type ToStartOfDay = (timestamp: number) => number;

export const toStartOfDay: ToStartOfDay = timestamp => timestamp - (timestamp % 86400000);

type UtcToUserTimezone = (timestamp: number) => number;

export const utcToUserTimezone: UtcToUserTimezone = (timestamp: number) => {
    const timeZoneOffset = getTimeZoneOffsetInMs(timestamp);
    return timestamp - timeZoneOffset;
};

export const utcToPreferredTimezone = (timestamp: number, timezone?: string): number => {
    if (timezone) {
        const timeZoneOffset = getTimezoneOffset(timezone, timestamp);
        return timestamp + timeZoneOffset;
    }
    return utcToUserTimezone(timestamp);
};

export const getDateInUserTimezone = (dateUTC: number) => toStartOfDay(utcToUserTimezone(dateUTC));

export const getDateInPreferredTimezone = (dateUTC: number, timezone?: string): number =>
    toStartOfDay(utcToPreferredTimezone(dateUTC, timezone));

export const formatDayLabel = timestamp => {
    const timeZoneOffset = getTimeZoneOffsetInMs(+timestamp);

    return format(+timestamp + timeZoneOffset, 'MM.dd');
};
